import { render, staticRenderFns } from "./Balance.icon.vue?vue&type=template&id=45d6be5c&"
import script from "./Balance.icon.vue?vue&type=script&lang=js&"
export * from "./Balance.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports